import {connect} from '../../app/connect';
import TemplateCategoriesManageModal from './TemplateCategoriesManageModal';
import {getIsTemplateCategoriesManageModalOpen, getTemplateCategories} from '../../app/selectors';
import {
  closeManageTemplateCategoriesModal,
  createTemplateCategoryAction,
  showNotificationAction
} from '../../app/actions';
import {deleteTemplateCategoryAction, fetchCategoryTemplatesAction} from '../../app/templates/templates-actions';

const mapStateToProps = state => ({
  categories: getTemplateCategories(state),
  isOpen: getIsTemplateCategoriesManageModalOpen(state)
});

const mapDispatchToProps = {
  close: closeManageTemplateCategoriesModal,
  createTemplateCategoryAction,
  showNotificationAction,
  fetchCategoryTemplatesAction,
  deleteTemplateCategoryAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateCategoriesManageModal);
